import { AxiosResponse } from "axios";

import api from 'utils/apiClient';
import { AuthInfo, LoginData } from 'store/auth/auth.actions';

export const login = (data: LoginData): Promise<AxiosResponse<AuthInfo>> => {
  return api.post('/auth', data);
};
